import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  disconnectXeroConnection,
  getXeroConnection,
  selectXeroTenant,
  startXeroHubConnect,
} from '@/api/xero-connection-api';

export const xeroConnectionKeys = {
  all: ['xeroConnection'] as const,
  forMember: (memberId: number) => [...xeroConnectionKeys.all, memberId] as const,
};

export const useXeroConnection = (memberId: number) => {
  return useQuery({
    queryKey: xeroConnectionKeys.forMember(memberId),
    queryFn: getXeroConnection,
    enabled: memberId > 0,
  });
};

export const useStartXeroHubConnect = () => {
  return useMutation({
    mutationFn: startXeroHubConnect,
  });
};

export const useSelectXeroTenant = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: selectXeroTenant,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: xeroConnectionKeys.all });
    },
  });
};

export const useDisconnectXeroConnection = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: disconnectXeroConnection,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: xeroConnectionKeys.all });
    },
  });
};
